import React from "react";
import { motion } from "framer-motion";
import { CalendarIcon, UsersIcon } from "lucide-react";
import type { Activity } from "../types/cafe";
import { formatIDR } from "../utils/currency";
interface ActivityCardProps {
  activity: Activity;
  onJoin: (id: string) => void;
}
export function ActivityCard({
  activity,
  onJoin
}: ActivityCardProps) {
  const lowSpots = activity.spotsLeft <= 5;
  return <motion.article layout initial={{
    opacity: 0,
    scale: 0.96
  }} animate={{
    opacity: 1,
    scale: 1
  }} exit={{
    opacity: 0,
    scale: 0.96
  }} transition={{
    duration: 0.22,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex h-full flex-col overflow-hidden rounded-card bg-white shadow-[0_1px_2px_rgba(44,34,30,0.06)] ring-1 ring-cream-line" data-id="element-29" data-mp="3rzblhesy12w">
      <div className="relative aspect-[4/3] overflow-hidden" data-id="element-30" data-mp="1o82mzh0bgvbf">
        <img src={activity.image} alt="" className="h-full w-full object-cover" data-id="element-31" data-mp="1o8vmpy0uykk2" />
        <span className="absolute left-3 top-3 rounded-full bg-cream px-3 py-1 text-xs font-semibold text-espresso" data-id="element-32" data-mp="1t5vv4fl6jzec">
          {activity.category}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-5" data-id="element-33" data-mp="12c9edakczyft">
        <h3 className="text-lg font-semibold tracking-tight text-ink" data-id="element-34" data-mp="129nabkwog12c">{activity.title}</h3>
        <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-35" data-mp="1gzui96p261os">{activity.description}</p>

        <div className="mb-5 mt-4 flex flex-col gap-1.5 text-sm text-ink-muted" data-id="element-36" data-mp="1c22rwh42anmp">
          <span className="flex items-center gap-2" data-id="element-37" data-mp="ocrn8ojlc93a">
            <CalendarIcon className="h-4 w-4 text-sage" aria-hidden="true" data-id="element-38" data-mp="jcvkesmmqnpb" />
            {activity.schedule}
          </span>
          <span className={`flex items-center gap-2 ${lowSpots ? "font-medium text-[#A5532E]" : ""}`} data-id="element-39" data-mp="xcwvt20itdj1">
            <UsersIcon className={`h-4 w-4 ${lowSpots ? "" : "text-sage"}`} aria-hidden="true" data-id="element-40" data-mp="tatfo02wpkrf" />
            Sisa {activity.spotsLeft} tempat minggu ini
          </span>
        </div>

        <div className="mt-auto flex items-end justify-between gap-3 border-t border-cream-line pt-4" data-id="element-41" data-mp="24qrkfrr1xkmu">
          <div data-id="element-42" data-mp="11fu9xut2bms5">
            <p className="text-lg font-semibold text-ink" data-id="element-43" data-mp="11e9e81v0hxsp">{formatIDR(activity.price)}</p>
            <p className="text-xs text-ink-muted" data-id="element-44" data-mp="16dmcdirc2ral">{activity.priceNote}</p>
          </div>
          <button type="button" onClick={() => onJoin(activity.id)} className="whitespace-nowrap rounded-full bg-espresso px-4 py-2.5 text-sm font-semibold text-cream transition-[background-color,transform] duration-150 ease-out hover:bg-sage active:scale-[0.97]" data-id="element-45" data-mp="1bcyy206gxsbl">
            Ikut Aktivitas
          </button>
        </div>
      </div>
    </motion.article>;
}